import { render, staticRenderFns } from "./HolidaysCalendar.vue?vue&type=template&id=7bf854f2&scoped=true"
import script from "./HolidaysCalendar.vue?vue&type=script&lang=js"
export * from "./HolidaysCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf854f2",
  null
  
)

export default component.exports